import { TextLink } from '@/modules/Frontend/UiBlocks'

import { STIHL_CATEGORY_ID } from '../../../lib'
import { useProductAttributes } from '../../../state'

interface BrandsProps {
  logoUrl?: string
}

export function Brands({ logoUrl }: BrandsProps) {
  const { categories } = useProductAttributes()

  const targetCategory = categories?.find((category) => category.id === STIHL_CATEGORY_ID)

  if (!targetCategory) return null

  const manufacturerUrl = targetCategory.url_path
    ? targetCategory.url_path.replace('default-category/', '') + '.html'
    : '#'

  return (
    <div className="p-3 xl:p-6">
      <TextLink
        href={manufacturerUrl}
        className="flex flex-col justify-center text-center gap-2 leading-5 xl:leading-7"
      >
        {logoUrl && <img src={logoUrl} alt="Brand Logo" className="mx-auto w-52" />}
        <span>Vezi toate produsele STIHL</span>
      </TextLink>
    </div>
  )
}
